import getIdentityStatus from 'features/Onboarding/modules/Identity/libs/getIdentityStatus';
import getQesStatus from 'features/Onboarding/modules/Qes/libs/getQesStatus';
import { ApplicantType, ApplicationType } from 'features/Onboarding/types';

import { State } from '../../machine';
import model from '../../machine/model';
import locales from './locales';
import {
  GetVerificationStep,
  VerificationStatus,
  VerificationStepCategory,
} from './types';

const getQesStep: GetVerificationStep = ({
  applicantType,
  applicationType,
  verificationData,
}) => {
  const status = getQesStatus({
    companyUser: verificationData.viewer.companyUser,
  });

  const idStatus = getIdentityStatus({
    companyUser: verificationData.viewer.companyUser,
  });

  const isOnboardingHub =
    applicationType === ApplicationType.Standard &&
    applicantType === ApplicantType.AccountHolder;

  return {
    // There is no specific error for this step ; only global errors and an invalid status.
    errors: [],
    id: State.QES,
    metadata: {
      category: VerificationStepCategory.PersonalInfo,
      event: model.events.GO_QES(),
      iconName: 'shield',
      // The user should never be able to complete this step before the identity check step.
      isHidden:
        isOnboardingHub ||
        idStatus === VerificationStatus.ToDo ||
        idStatus === VerificationStatus.Invalid ||
        status === VerificationStatus.Completed,
      label: locales.qes.home.label,
    },
    status,
  };
};

export default getQesStep;
